import { DEFAULT_THEME, PRESET_THEMES, THEME_STORAGE_KEY } from '@/config/theme'
import { applyTheme } from '@/utils/applyTheme'

function loadTheme() {
  try {
    const saved = JSON.parse(localStorage.getItem(THEME_STORAGE_KEY) || '{}')
    return { ...DEFAULT_THEME, ...saved }
  } catch (e) {
    return { ...DEFAULT_THEME }
  }
}

const state = {
  theme: loadTheme(),
  settingsVisible: false,
}

const mutations = {
  SET_THEME(state, partial) {
    state.theme = { ...state.theme, ...partial }
    applyTheme(state.theme)
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(state.theme))
  },
  RESET_THEME(state) {
    state.theme = { ...DEFAULT_THEME }
    applyTheme(state.theme)
    localStorage.removeItem(THEME_STORAGE_KEY)
  },
  APPLY_PRESET(state, presetKey) {
    const preset = PRESET_THEMES[presetKey]
    if (!preset) {
      return
    }
    state.theme = { ...DEFAULT_THEME, ...preset.theme }
    applyTheme(state.theme)
    localStorage.setItem(THEME_STORAGE_KEY, JSON.stringify(state.theme))
  },
  SET_SETTINGS_VISIBLE(state, visible) {
    state.settingsVisible = visible
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
